// components
import LineShape01 from "@/components/shapes/LineShape01";
import PlaneShape02 from "@/components/shapes/PlaneShape02";
import DollShape01 from "@/components/shapes/DollShape01";
import ParasuitShape02 from "@/components/shapes/ParasuitShape02";
import FrameShape04 from "@/components/shapes/FrameShape04";
import BeeShape02 from "@/components/shapes/BeeShape02";
import BottomShape03 from "@/components/shapes/BottomShape03";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// type
import { TMainPageLayoutV3 } from "../type";
// utilities
import { pageNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const MNPG050 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG050.rendered: ", props);
    
    if ( !props.params?.["contentDetails"] ) return null;

    const languageVersion = pageNameDescriptionLanguageVersion(props.params["contentDetails"]?.languageVersions);

    return (
        <div className="breadcrumb-wrapper bg-cover">
            <LineShape01 />
            <PlaneShape02 className="float-bob-y" />
            <DollShape01 className="float-bob-x" />
            <ParasuitShape02 className="float-bob-y" />
            <FrameShape04 />
            <BeeShape02 className="float-bob-x" />
            <BottomShape03 />
            <div className="container">
                <div className="page-heading">
                    <h1 data-aos-duration="800" data-aos="fade-up" data-aos-delay="300">
                        {languageVersion?.name}
                    </h1>
                    <RMDRComponentSanitizer languageVersion={languageVersion} variant="p" valueExpr="value" removeTag />
                </div>
            </div>
        </div>
    )
}

export default MNPG050;
